import { menuRegistry } from '@/common/menu/menuRegistry';
import { registerRouteForModule } from '@/common/route/registerModules';
import router, { ROUTE_NAME_RFM } from './router';

menuRegistry.registerMenu([
    {
        parent: 'Payment',
        key: 'RFM',
        name: 'RFM System',
        icon: 'fas fa-cubes'
    },
    {
        parent: 'Payment.RFM',
        key: 'Group',
        name: 'Group',
        icon: 'fas fa-layer-group',
        route: { name: ROUTE_NAME_RFM.GROUP.INDEX }
    },
    {
        parent: 'Payment.RFM',
        key: 'Recency',
        name: 'Recency',
        icon: 'fas fa-calendar-alt',
        route: { name: ROUTE_NAME_RFM.RECENCY.INDEX }
    },
    {
        parent: 'Payment.RFM',
        key: 'Frequency',
        name: 'Frequency',
        icon: 'fas fa-file-invoice-dollar',
        route: { name: ROUTE_NAME_RFM.FREQUENCY.INDEX }
    },
    {
        parent: 'Payment.RFM',
        key: 'Monetary',
        name: 'Monetary',
        icon: 'fas fa-dollar-sign',
        route: { name: ROUTE_NAME_RFM.MONETARY.INDEX }
    },
    {
        parent: 'Payment.RFM',
        key: 'Persona',
        name: 'Persona',
        icon: 'fas fa-users-cog',
        route: { name: ROUTE_NAME_RFM.PERSONA.INDEX }
    },
    {
        parent: 'Payment.RFM',
        key: 'Segmentation',
        name: 'Segmentation',
        icon: 'fas fa-sliders-h',
        route: { name: ROUTE_NAME_RFM.SEGMENTATION }
    }
]);

export default registerRouteForModule(router);
